import React from 'react';
import useLocalTranslation from '../../hooks/useLocalTranslation';
import { useContext, useState } from 'react';
import { Button, Input, Modal, ModalManagerContext } from '@pega/cosmos-react-core';

export interface EditWebhookProps {
  selectedWebhook: string;
  updateWebhook: Function;
  index: number;
  webhooks: any;
}

export const isValidUrl = (url: string): boolean => {
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i;
  return urlRegex.test(url.trim());
};
const EditWebhookModal: React.FC<EditWebhookProps> = ({ selectedWebhook, updateWebhook, index, webhooks }) => {
  const translate = useLocalTranslation();
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);
  const [webhook, setWebhook] = useState(selectedWebhook);
  const [webhookError, setWebhookError] = useState('');
  const onWebhookChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWebhook(event.target.value);
    setWebhookError('');
  };

  const save = () => {
    if (isValidUrl(webhook) && !webhooks.includes(webhook)) {
      updateWebhook(webhook, index);
      dismiss();
    } else {
      setWebhookError(webhooks.includes(webhook) ? translate('existing_error') : translate('invalid_webhook'));
    }
  };

  return (
    <Modal
      center={true}
      heading=""
      autoWidth={true}
      actions={
        <>
          <Button onClick={dismiss}>{translate('cancel')}</Button>
          <Button variant="primary" onClick={save} disabled={Boolean(webhookError || !webhook)}>
            {translate('ok')}
          </Button>
        </>
      }
    >
      <Input
        label={translate('webhook_url')}
        type="text"
        autoComplete="off"
        value={webhook}
        onChange={onWebhookChange}
        info={webhookError}
        required={true}
        status={webhookError ? 'error' : undefined}
      />
    </Modal>
  );
};

export default EditWebhookModal;
